<template>
	<div>

		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Change Phone Number</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<div class="row">
						<div class="col-lg-8">
							<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
								<div v-if="!showOTPView">
									<div class="form-card">
										<div class="form-card-header">
											<h3>Personal Details</h3>
										</div>

										<div class="form-card-forms">


											<div class="row">
												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															Enter New Phone Number<span class="required">*</span>
														</label>
														<div class="input-group">
															<div class="input-group-prepend">
																<span class="input-group-text">60</span>
															</div>
															<input type="text" class="form-control" id="NewPhone" placeholder="New Phone" v-only-numeric=""
																		 name="NewPhone"
																		 autocomplete="off"
																		 v-model="vModel.NewPhone"
																		 data-vv-as='New phone'
																		 @keydown="ValidateMobile"
																		 :class="{'input': true, 'is-danger': errors.has('NewPhone') }" />
																<!-- <input type="text" class="form-control" id="NewPhone" placeholder="New Phone" 
																		 name="NewPhone"
																		 autocomplete="off"
																		 v-model="vModel.NewPhone"
																		 data-vv-as='New phone'
																		 v-validate="'required'"
																		 v-only-numeric=""
																		 :class="{'input': true, 'is-danger': errors.has('NewPhone') }" /> -->

														</div>
														<div v-show="errors.has('NewPhone')"
																 class="help is-danger">
															{{ errors.first('NewPhone') }}
														</div>
														<div v-show="!errors.has('NewPhone') && ShowMobileErrorMsg" class="help is-danger">
															Invalid Phone Number</div>
													</div>
												</div>

											</div>
											<div class="row">

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															Confirm New Phone Number<span class="required">*</span>
														</label>
														<div class="input-group">
															<div class="input-group-prepend">
																<span class="input-group-text">60</span>
															</div>
															<input type="text" class="form-control" id="ConfirmPhone" placeholder="Confirm  Phone" v-only-numeric=""
																		 name="ConfirmPhone"
																		 autocomplete="off"
																		 v-model="vModel.ConfirmPhone"
																		 data-vv-as='Confirm phone'
																		 v-validate="'required|confirmed:NewPhone'"
																		 maxlength="10"
																		 :class="{'input': true, 'is-danger': errors.has('ConfirmPhone') }" />

														</div>
														<div v-show="errors.has('ConfirmPhone')"
																 class="help is-danger">
															{{ errors.first('ConfirmPhone') }}
														</div>
													</div>
												</div>

											</div>
											<div class="row">

												<div class="col-lg-6">
													<div class="form-group">
														<label for="" class="label-detail">
															Password
															<span class='required-label'>*</span>
														</label>
														<input placeholder="Password" data-vv-as='Password' v-model="vModel.Password"
																	 class="form-control"
																	 v-validate="{required : true}"
																	 :class="{'input': true, 'is-danger': errors.has('Password') }"
																	 name="Password"
																	 type="password" />
														<div v-show="errors.has('Password')" class="help is-danger">
															{{ errors.first('Password') }}
														</div>
													</div>
												</div>
											</div>


										</div>
										<!-- eo form card forms -->
									</div>
									<!-- eo form card -->

									<div class="submit-option">
										<div class="left-option">
											<router-link :to="'/dashboard'" class="btn submit-lefticon-btn">
												<span class="left-icon">
													<i class="material-icons">chevron_left</i>
												</span>
												<span class="btn-content">Cancel</span>
											</router-link>
										</div>

										<div class="right-option">
											<button class="btn submit-lefticon-btn">
												<span class="left-icon">
													<i class="material-icons">phone</i>
												</span>
												<span class="btn-content">Update</span>
											</button>
										</div>
									</div>
									<!-- eo form card -->
								</div>
								<div v-else="">
									<div class="form-card mgt30 text-center otp">
										<div class="form-card-forms">
											<h4 class="header">Verification</h4>
											<h4 class="detail">To proceed, please request and enter your OTP number</h4>

											<div class="otp-form">

												<div class="form-group">
													<input type="text" id="otp" name="OTP" v-only-numeric="" autocomplete="off" v-model="OTP"
																 v-validate="'required|min:6|max:6'"
																 :class="{'input': true, 'is-danger': errors.has('OTP'),'opt-text-wrapper' :true,'form-control otp' : true }" />
													<div v-show="errors.has('OTP')" class="help is-danger">{{ errors.first('OTP') }}</div>
												</div>

												<button class="btn main-btn">Submit</button>
												<button class="btn btn-primary" @click="onResendOtp()">Resend otp</button>

											</div>
										</div>
									</div>
								</div>
							</form>



						</div>
						<!-- eo col-8 -->

						<div class="col-lg-4">
							<UserDetailSection />
						</div>
					</div>
					<!-- eo row -->

				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->







	</div>
</template>

<script>
	import Base from "../../shared/Base.vue";
	import CommonService from "../../services/common";
	import UserDetailSection from '../../shared/UserDetailSection.vue'

	export default {
		name: "ChangePhone",
		inject: ['$validator'],
		components: { UserDetailSection },
		extends: Base,
		beforeRouteEnter(to, from, next) {
			next();
		},
		created() { },
		data() {
			return {
				showOTPView: false,
				OTP: null,
				otpModel: {
					OtpId: null,
					Key: null
				},
				vModel: {
					NewPhone: null,
					ConfirmPhone: null,
					Password: null,
					tabIndex: 0
				},
				ShowMobileErrorMsg: false
			};
		},
		methods: {
			onResendOtp: function () {
				var self = this;
				self.isProcessing = true;
				self.$http.post("mobile/otp/resend", self.otpModel).then(
					response => {
						self.$toastr("success", "OTP Resend Successfully");
						self.isProcessing = false;
					},
					error => {
						self.isProcessing = false;
					}
				);
			},

			onSubmit() {
				var self = this;
				if (self.vModel.NewPhone.length < 9) return;
				if (self.isProcessing) return;

				self.$validator.validateAll().then(result => {
					if (result) {
						var url = "account/initchangephone";
						var model = Object.assign({}, self.vModel);	
						model.NewPhone = `60${model.NewPhone}`;											     
						if (self.showOTPView) {
							url = "account/changephone";
							model = {
								OTP: self.OTP,
								NewPhone: model.NewPhone
							};
						}
						self.isProcessing = true;
						self.$http.post(url, model).then(
							response => {
								self.isProcessing = false;
								if (!self.showOTPView) {
									self.otpModel = response.body;
									self.showOTPView = true;
									self.$toastr("success", "OTP send successfully.");
								} else {
									self.$toastr("success", "Mobile number changed successfully.");

									if (window._sessionInterval != null) {
										clearInterval(window._sessionInterval);
									}

									CommonService.destroyStorage();
									self.$router.push("/account/login");
								}
							},
							error => {
								self.isProcessing = false;
							}
						);
					}
				});
			},
			ValidateMobile(event){
				var keyCode = event.keyCode ? event.keyCode : event.which;
			    if ((!(keyCode > 93 && keyCode < 106) && (keyCode < 48 || keyCode > 57)) ||  this.vModel.NewPhone.length > 9) {					
					event.preventDefault();
				}
				if(keyCode === 8){
					//on backspace
					this.vModel.NewPhone = this.vModel.NewPhone.slice(0,-1);
					if(this.vModel.NewPhone.length < 9){
						this.ShowMobileErrorMsg = true;
					}
				}else{
					var len = this.vModel.NewPhone === undefined ? 0 : this.vModel.NewPhone.length;
					if(len < 8){
						this.ShowMobileErrorMsg = true;
					}else{
						this.ShowMobileErrorMsg = false;
					}
				}
			}
		}
	};
</script>
